import React, { useState } from 'react';

import { useConfiguration } from '../../../hooks/Configuration';
import { IDialogWithId, useDialogs } from '../../../hooks/Dialogs';

export interface IPhoneDialogProps {
    id?: IDialogWithId['id']
    onSubmit: (phone: string) => void
}

function PhoneDialog({ id, onSubmit }: IPhoneDialogProps) {
    const { closeDialog } = useDialogs();
    const configuration = useConfiguration();
    const [phone, setPhone] = useState<string>('');

    return (
        <div>
            <div
                className='stx-info'
                style={{
                    backgroundColor: 'lightblue'
                }}>
                Prosím, zadejte svůj telefon, na kterém vás může náš operátor kontaktovat.
            </div>
            <form onSubmit={e => {
                e.preventDefault();
                if (!phone?.length) return;

                closeDialog(id || '');
                onSubmit(phone);
            }}>
                <div className='stx-input'>
                    <input
                        id='name'
                        name='phone'
                        style={{

                        }}
                        placeholder='Váš telefon...'
                        value={phone}
                        onChange={({ target }) => setPhone(target.value)}
                        autoFocus
                        autoComplete='off' />
                </div>
                <button
                    className='stx-button'
                    style={{
                        backgroundColor: configuration?.styles.btnSendColor,
                        color: configuration?.styles.windowBgColor
                    }}
                    disabled={!phone?.length}>
                    Odeslat
                </button>
            </form>
        </div>
    );
}

export default PhoneDialog;
